import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';
import Clipboard from 'v-clipboard';
import VCalendar from 'v-calendar';
import routes from './router';
import VueLogger from 'vuejs-logger';
import VTooltip from 'v-tooltip'    //https://github.com/Akryum/v-tooltip#usage
import DotLoader from 'vue-spinner/src/DotLoader.vue';
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import VueNoty from 'vuejs-noty';
import store from './store';
import Unicon from 'vue-unicons/dist/vue-unicons-vue2.umd' //https://antonreshetov.github.io/vue-unicons/
import {
    uniLockAlt,
    uniUnlockAlt,
    uniPlus,
    uniSetting,
    uniTrashAlt,
    uniUser,
    uniRedo,
    uniBars,
    uniInfoCircle,
    uniFilter,
    uniCopy,
    uniCog,
    uniExclamationTriangle,
    uniSpinnerAlt,
    uniCheckCircle,
    uniTimesCircle,
    uniClock, uniExternalLinkAlt,
    uniExclamationCircle, uniMouse, uniEuro, uniArrowGrowth, uniBolt, uniCheck
} from 'vue-unicons/dist/icons'

//import VueCurrencyInput from 'vue-currency-input'

Unicon.add([uniLockAlt, uniUnlockAlt, uniPlus, uniSetting, uniTrashAlt, uniUser, uniRedo, uniBars, uniInfoCircle, uniFilter, uniCopy, uniCog, uniExclamationTriangle, uniSpinnerAlt,
    uniCheckCircle, uniMouse, uniEuro, uniBolt, uniArrowGrowth, uniCheck, uniExternalLinkAlt,
    uniTimesCircle,
    uniClock,
    uniExclamationCircle]);
import moment from 'moment';

Vue.prototype.moment = moment;

const isProduction = process.env.NODE_ENV === 'production';

const options = {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};


Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.component('DotLoader', DotLoader);
Vue.component('ClipLoader', ClipLoader);
Vue.use(VueLogger, options);
Vue.use(Clipboard);
Vue.use(VueRouter);
//Vue.use(VueCurrencyInput);
Vue.use(VCalendar);
Vue.use(VueNoty, {
    timeout: 4000,
    layout: 'bottomRight',
    theme: 'metroui'
});
Vue.use(VTooltip, {
    defaultTrigger: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? 'click' : 'hover',
    defaultOffset: 7,
    defaultDelay: 200,
});
Vue.use(Unicon);
Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

const router = new VueRouter({routes});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

